<template>
    <div class="header-pagination">
        <div class="text-right">
            <nav aria-label="Page navigation">
                <paginate
                    :pageCount="pages.last_page"
                    :containerClass="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :next-class="'page-item'"
                    :prev-text="'＜'"
                    :next-text="'＞'"
                    :next-link-class="'page-link'"
                    :clickHandler="clickHandler">
                </paginate>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        pages: {
            required: true,
            type: Object
        }
    },

    methods: {
        clickHandler(page) {
            this.$emit('clickPaginate', page)
        }
    }
}
</script>

<style scoped>
    /*-------------header-pagination-------------------*/
    .header-pagination {
        margin-bottom: 1rem;
    }

    .text-right {
        text-align: right;
    }
    
    .form-horizontal {
        width: 30rem;
    }

    .flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

/*-------------pagination-------------------*/

    .pagination .active a {
        color: #143361;
        background-color: transparent;
        font-weight: 600;
    }

    .pagination .active a:hover {
        background-color: transparent;
        color: #143361;
        border: 0px;
    }

    .pagination .active a:focus {
        background-color: transparent;
        color: #143361;
        outline: none;
    }

    .pagination li a {
        border: 1px;
        margin-left: 0px;
        color: #707070;
        padding: 7px 7px;
        margin: 0px 10px;
    }

    .pagination li a:hover {
        background-color: transparent;
        color: #4a90e2;
        padding-bottom: 2px;
        border-bottom: 1px solid;
    }

    .pagination li a:focus {
        outline: none;
        background-color: transparent;
    }

    .pagination li:first-child a,
    .pagination li:last-child a {
        border: 2px solid #143361 !important;
        border-radius: 6px;
        margin: 0px;
        padding: 6px 12px;
        border: 2px solid;
        font-size: 14px;
        color: #143361;
    }

    .pagination li:first-child a:hover,
    .pagination li:last-child a:hover {
        text-decoration: none !important;
        color: #fff;
        background-color: #143361;
    }

    .pagination li:first-child a:focus,
    .pagination li:last-child a:focus {
        outline: none;
    }

    .results-number {
        width: 30rem;
    }

    @media screen and (max-width: 800px) {

        .flex {
            flex-direction: column;
        }

        .results-number {
            width: 18rem;
        }
    }


</style>